export enum SmartFlowOperations {
  Evaluate = 'Evaluate',
  Reset = 'Reset',
}
